const fractionalEngagementLevel = {
    advisory: {
        name: "Advisory",
        retainerLabel: "Advisory Retainer",
        definition: "A strategic, senior-level Learning & Development partnership providing as-needed guidance, planning, and decision support without responsibility for day-to-day execution."
    },

    operational: {
        name: "Operational",
        retainerLabel: "Operational Retainer",
        definition: "A hands-on, flexible Learning & Development partnership delivering continuous support across multiple learning initiatives as priorities evolve.",
    },

    embedded: {
        name: "Embedded",
        retainerLabel: "Embedded Retainer",
        definition: "A deeply integrated Learning & Development partnership in which a dedicated professional operates as an extension of the Client's internal team to support ongoing, enterprise-level learning initiatives."
    },

    notSure: {
        name: "Not Sure",
        retainerLabel: "Not Sure",
        definition: "We'll help determine the right level based on your needs."
    }
}

export default fractionalEngagementLevel;
